module.exports = __webpack_public_path__ + "static/img/pixartwo.e7eb6d9b.png";